import { CloseOutlineIcon } from '@carboncopyco/icons';
import { InlineLink, InputText } from '@carboncopyco/ui';
import { useFolderManageAccess } from './FolderManageAccessContext';

export const FolderManageAccessSearch = () => {
  const { searchKey, setSearchKey, clear, selectAll } = useFolderManageAccess();
  return (
    <div className="w-full mb-4">
      <div className="flex justify-center items-center w-full">
        <InputText
          value={searchKey}
          rightElement={
            searchKey?.length > 0 && (
              <div
                className="text-ds-primary-300"
                onClick={() => setSearchKey('')}
              >
                <CloseOutlineIcon />
              </div>
            )
          }
          size="xl"
          fullWidth
          placeholder="Search for workspace or tag"
          onChange={(event) => setSearchKey(event?.target?.value)}
          onKeyUp={({ key }) => key === 'Escape' && setSearchKey('')}
        />
      </div>
      <div className="flex justify-between items-center w-full mt-4 border-b pb-2">
        <InlineLink
          label="Select All"
          className="mb-0.5 cursor-pointer"
          onClick={selectAll}
        />

        <InlineLink
          underline={false}
          label="Clear"
          className="mb-0.5 cursor-pointer text-ds-primary-300"
          onClick={clear}
        />
      </div>
    </div>
  );
};
